import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import CsatSurveysAPI from '../../api/csatSurveys';
import { CSAT_SURVEY_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCsatSurveys(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }) {
    commit(types.SET_CSAT_SURVEY_UI_FLAG, { isFetching: true });
    try {
      const response = await CsatSurveysAPI.get(true);
      const sortedSurveys = response.data.payload.sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      commit(types.SET_CSAT_SURVEYS, sortedSurveys);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CSAT_SURVEY_UI_FLAG, { isFetching: false });
    }
  },

  create: async function create({ commit }, cannedObj) {
    commit(types.SET_CSAT_SURVEY_UI_FLAG, { isSubmitting: true });
    try {
      const response = await CsatSurveysAPI.create(cannedObj);
      AnalyticsHelper.track(CSAT_SURVEY_EVENTS.CREATE);
      commit(types.ADD_CSAT_SURVEY, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CSAT_SURVEY_UI_FLAG, { isSubmitting: false });
    }
  },

  update: async function update({ commit }, { id, ...updateObj }) {
    commit(types.SET_CSAT_SURVEY_UI_FLAG, { isSubmitting: true });
    try {
      const response = await CsatSurveysAPI.update(id, updateObj);
      AnalyticsHelper.track(CSAT_SURVEY_EVENTS.UPDATE);
      commit(types.EDIT_CSAT_SURVEY, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CSAT_SURVEY_UI_FLAG, { isSubmitting: false });
    }
  },

  delete: async function deleteCsatSurvey({ commit }, id) {
    commit(types.SET_CSAT_SURVEY_UI_FLAG, { isDeleting: true });
    try {
      await CsatSurveysAPI.delete(id);
      AnalyticsHelper.track(CSAT_SURVEY_EVENTS.DELETED);
      commit(types.DELETE_CSAT_SURVEY, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CSAT_SURVEY_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CSAT_SURVEY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CSAT_SURVEYS]: MutationHelpers.set,
  [types.ADD_CSAT_SURVEY]: MutationHelpers.create,
  [types.EDIT_CSAT_SURVEY]: MutationHelpers.update,
  [types.DELETE_CSAT_SURVEY]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
